import { render } from "./riskList2.vue?vue&type=template&id=b881490c&scoped=true"
import script from "./riskList2.vue?vue&type=script&lang=js"
export * from "./riskList2.vue?vue&type=script&lang=js"

import "./riskList2.vue?vue&type=style&index=0&id=b881490c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b881490c"

export default script